import { Contractor } from 'common/models/harvestData/contractor';
import { FC, useCallback, useContext } from 'react';
import { InfoLabel, selectBaseStyling } from '../WizardComponents/wizardStyles';
import { WizardNumericInput } from 'common/components/WizardControls/WizardNumericInput';
import {
  WizardDropdown,
  WizardDropdownOption,
} from 'common/components/WizardControls/WizardDropdown';
import {
  AssignCrewRow,
  DividerWithMargin,
  DropdownRemoveContainer,
  bigInputSize,
  smallInputSize,
} from './styles';
import { CrewAssignmentContext } from './CrewAssignmentWizard';
import { useFormContext } from 'react-hook-form';

export type ContractorAndBins = {
  /** String auto-generated by `useForm`'s `useFieldArray` hook */
  id: string;
  contractor: WizardDropdownOption<Contractor> | null;
  bins: string | null;
};

export const AssignCrewForm: FC<{
  itemIndex: number;
  removeBtn: () => JSX.Element;
}> = ({ itemIndex, removeBtn }) => {
  const { contractorOptions, isLoading } = useContext(CrewAssignmentContext);
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const createNestedPathError = useCallback(
    (name: string) => {
      // react-hook typing does not account for nested errors
      return (
        errors.contractorsAndBins as unknown as Record<
          string,
          Record<string, string>
        >[]
      )?.[itemIndex]?.[`${name}`]?.message;
    },
    [errors.contractorsAndBins, itemIndex],
  );

  return (
    <>
      <DividerWithMargin />
      <AssignCrewRow>
        <InfoLabel>FLC {itemIndex + 1}</InfoLabel>
        <DropdownRemoveContainer>
          <WizardDropdown<Contractor>
            name={`contractorsAndBins[${itemIndex}].contractor`}
            options={contractorOptions}
            formControl={control}
            styles={selectBaseStyling}
            isLoading={isLoading}
            maxWidth={smallInputSize}
            nestedPathError={createNestedPathError('contractor')}
          />
          {removeBtn()}
        </DropdownRemoveContainer>
      </AssignCrewRow>
      <AssignCrewRow>
        <InfoLabel>Bins</InfoLabel>
        <WizardNumericInput
          name={`contractorsAndBins[${itemIndex}].bins`}
          maxWidth={bigInputSize}
          nestedPathError={createNestedPathError('bins')}
        />
      </AssignCrewRow>
    </>
  );
};
